(() => {
  angular
    .module('app.settings')
    .controller('AdformEditModalController', AdformEditModal);

  AdformEditModal.$inject = [
    '$interval',
    'close',
    'provider',
    'integrations',
    'CountriesList',
    'allowedMetrics',
    'allowedCountries',
  ];

  function AdformEditModal(
    $interval,
    close,
    provider,
    integrations,
    CountriesList,
    allowedMetrics,
    allowedCountries,
  ) {
    const vm = this;
    let originCountry = 'DK';
    let originMetrics = [];
    let originClients = [];
    let originBlockedMediaIds = [];
    let originSetupVideoFunnelEvents = true;
    let closeWithReload = false;

    vm.saveEnable = () => ((
      vm.countryEdited ||
      vm.clientsEdited ||
      vm.metricsEdited ||
      vm.setupVideoFunnelEventsEdited ||
      vm.blockedMediaIdsEdited
    ) && vm.clientsAvailable);

    vm.loadIntegrations = () => {
      vm.isProcessBusy = true;

      provider.fetchIntegrations()
        .then(({ data }) => {
          initIntegrations(data);
        })
        .catch(error => {
          console.error(error.statusText);
        })
        .finally(() => {
          vm.isProcessBusy = false;
        });
    }

    function initIntegrations(data) {
      const {
        country,
        qualityMetrics,
        selectedAdvertisers,
        lastIntegrationDateUTC,
        agencyNames,
        lastErrorDate,
        lastErrorMessage,
        connectedAccountEmail,
        setupVideoFunnelEvents,
        blockedMediaIds,
      } = data;

      originCountry = country;
      originMetrics = qualityMetrics || [];
      originClients = selectedAdvertisers || [];
      originBlockedMediaIds = blockedMediaIds?.sort() || [];
      originSetupVideoFunnelEvents = setupVideoFunnelEvents;

      vm.email = connectedAccountEmail;
      vm.account = agencyNames;
      vm.lastErrorDate = lastErrorDate && new Date(lastErrorDate);
      vm.lastErrorMessage = lastErrorMessage;
      vm.lastIntegrationDate = lastIntegrationDateUTC && new Date(lastIntegrationDateUTC);
      vm.setupVideoFunnelEvents = setupVideoFunnelEvents;
      vm.blockedMediaIds = blockedMediaIds || [];

      initCountries();
      initMetrics();

      loadClients();
      loadMedias();
    };
    initIntegrations(integrations);


    /* ************************************************************* */
    /* *************************** Clients ************************* */
    /* ************************************************************* */
    vm.clients = [];
    vm.clientsMenu = [];
    vm.clientsAvailable = true;
    vm.search = '';

    function loadClients() {
      vm.isProcessBusy = true;

      return provider.fetchClients()
        .then(({ data }) => {
          if (data.error?.ex) {
            const ex = JSON.parse(data.error.ex);
            console.error('GET advertisers error:', ex?.errorMessage);
            Notification.showSimpleError(ex?.errorMessage);
            vm.clientsLoadingError = true;

            return false;
          }

          vm.clients = data;
          vm.clientsLoadingError = false;

          vm.clientsMenu = [{
            id: 'all',
            label: `All clients (${data.length})`,
          }, {
            id: 'selected',
            label: 'Selected clients only',
          }];

          vm.selectedClients = originClients && originClients.length === data.length ?
            vm.clientsMenu[0] : vm.clientsMenu[1];

          if (!vm.selectedClients || vm.selectedClients.length === 0) {
            vm.clientsAvailable = false;
          }
        })
        .catch(error => {
          console.error(error.statusText);
          Notification.showSimpleError(error.statusText);
        })
        .finally(() => {
          vm.isProcessBusy = false;
        });
    };

    const onEditClients = () => {
      const selectedClients = vm.clients.filter(item => item.isSelected).map(item => item.name);
      vm.clientsEdited = (originClients && !_.isEqual(selectedClients.sort(), originClients.sort())) ||
        (!originClients && selectedClients.length !== 0);
      vm.clientsAvailable = selectedClients.length !== 0;
    };

    const getAdvertiserIds = () => (
      vm.clients
        .filter(item => vm.selectedClients.id === 'all' || item.isSelected)
        .map(item => item.id)
    );

    vm.onSelectAllClients = select => {
      angular.forEach(vm.clients, client => client.isSelected = !!select);
      onEditClients();
    };

    vm.onCheckClient = client => {
      client.isSelected = !client.isSelected;
      onEditClients();
    };

    vm.onSelectClients = item => {
      vm.selectedClients = item;
      if (item.id === 'all') {
        vm.onSelectAllClients(true);
      } else {
        onEditClients();
      }
    };

    vm.handleShowSearch = () => vm.searchVisible = !vm.searchVisible;
    vm.handleClearSearch = () => {
      vm.searchVisible = false;
      vm.search = '';
    };



    /* ************************************************************* */
    /* *************************** Country ************************* */
    /* ************************************************************* */
    function initCountries() {
      vm.countries = CountriesList.filter(item => allowedCountries.includes(item.code));
      vm.currentCountry = vm.countries.find(item => item.code === originCountry);
    };

    vm.onSelectCountry = country => {
      vm.currentCountry = country;
      vm.countryEdited = country.code !== originCountry;
    };


    /* ************************************************************* */
    /* ********************** Tracking details ********************* */
    /* ************************************************************* */
    function initMetrics() {
      vm.metrics = allowedMetrics.map(item => ({
        ...item,
        checked: originMetrics && originMetrics.includes(item.key),
      }));
    }

    const onEditMetrics = () => {
      const selectedMetrics = vm.metrics.filter(item => item.checked).map(item => item.key);
      vm.metricsEdited = (originMetrics && !_.isEqual(selectedMetrics.sort(), originMetrics.sort())) ||
        (!originMetrics && selectedMetrics.length !== 0);
    };

    vm.onCheckMetric = metric => {
      const activeMetric = vm.metrics.find(item => item.name === metric.name);
      activeMetric.checked = !activeMetric.checked;
      onEditMetrics();
    };

    vm.showVideoFunnelMessage = false;
    vm.onSetupVideoFunnelEvents = () => {
      vm.setupVideoFunnelEvents = !vm.setupVideoFunnelEvents;
      vm.showVideoFunnelMessage = !vm.setupVideoFunnelEvents;

      vm.setupVideoFunnelEventsEdited = vm.setupVideoFunnelEvents != originSetupVideoFunnelEvents;
    };


    /* ************************************************************* */
    /* *************************** Medias ************************** */
    /* ************************************************************* */
    vm.medias = [];
    vm.mediasLoading = true;
    function loadMedias() {
      provider.fetchMedias()
        .then(({ data }) => {
          if (data.error?.ex) {
            const ex = JSON.parse(data.error.ex);
            console.error('GET medias error:', ex?.errorMessage || data.error.message);
            Notification.showSimpleError(ex?.errorMessage || data.error.message);
            vm.mediasLoadingError = ex?.errorMessage || data.error.message;

            return false;
          }

          vm.mediasLoadingError = false;
          vm.medias = data.map(item => ({
            ...item,
            blocked: vm.blockedMediaIds.includes(item.id),
          }));
        })
        .finally(() => {
          vm.mediasLoading = false;
        });
    }

    const getBlockedMediaIds = () => vm.medias.filter(({ blocked }) => blocked).map(({ id }) => id).sort();
    const isBlockedMediaIdsEdited = () => !angular.equals(getBlockedMediaIds(), originBlockedMediaIds);
    const updateActionsDisabled = () => {
      vm.mediaAddSelectedEnabled = vm.medias.some(item => item.checked && !item.blocked);
      vm.mediaRemoveSelectedEnabled = vm.medias.some(item => item.checked && item.blocked);
    };

    vm.handleCheckMedia = ({ id }) => {
      const media = vm.medias.find(item => item.id === id);
      media.checked = !media.checked;

      updateActionsDisabled();
    };

    vm.handleAddSelected = () => {
      vm.filteredMedias.forEach(item => {
        if (item.checked) {
          item.blocked = true;
        }
      });

      vm.blockedMediaIdsEdited = isBlockedMediaIdsEdited();
      vm.showBlockedMediaMessage = vm.blockedMediaIdsEdited;
      updateActionsDisabled();
    };

    vm.handleRemoveSelected = () => {
      vm.filteredBlockedMedias.forEach(item => {
        if (item.checked) {
          item.blocked = false;
        }
      });

      vm.blockedMediaIdsEdited = isBlockedMediaIdsEdited();
      vm.showBlockedMediaMessage = vm.blockedMediaIdsEdited;
      updateActionsDisabled();
    };

    vm.handleShowMediaSearch = () => vm.mediaSearchVisible = !vm.mediaSearchVisible;
    vm.handleClearMediaSearch = () => {
      vm.mediaSearchVisible = false;
      vm.mediaSearch = '';
    };



    /* ************************************************************* */
    /* *************************** Actions ************************* */
    /* ************************************************************* */
    vm.onReconnect = () => {
      vm.isProcessBusy = true;

      const adform = window.open(provider.oauth, '_blank');
      const interval = $interval(() => {
        if (!adform.window) {
          $interval.cancel(interval);
          vm.loadIntegrations();

          closeWithReload = true;
        }
      }, 1000);
    };

    vm.onSave = () => {
      vm.isProcessBusy = true;
      const selectedClients = getAdvertiserIds();
      const selectedMetrics = vm.metrics.filter(item => item.checked).map(item => item.key);

      provider.updateIntegrations({
        country: vm.countryEdited ? vm.currentCountry.code : undefined,
        advertiserIds: vm.clientsEdited ? selectedClients : undefined,
        qualityMetrics: vm.metricsEdited ? selectedMetrics : undefined,
        setupVideoFunnelEvents: vm.setupVideoFunnelEvents,
        blockedMediaIds: getBlockedMediaIds(),
      })
      .then(() => {
        close({}, 0);
      })
      .catch(error => {
        console.error(error);
        if (error.status === 400) {
          const message = /\[(.*?)\]/.exec(error.data.message);
          const ids = message ? message[1].split(',') : [];
          const clients = vm.clients.filter(({ id }) => ids.includes(id.toString()));

          vm.clientsAlreadyUsed = clients.map(({ name }) => name);
          vm.clientsAvailable = false;
        }
      })
      .finally(() => {
        vm.isProcessBusy = false;
      });
    };

    vm.onClose = () => close(closeWithReload, 0);

    const collapsed = {
      connect: false,
      clients: false,
      country: true,
      trackingDetails: true,
    };
    vm.sectionCollapsed = section => collapsed[section];
    vm.onSectionCollapse = section => collapsed[section] = !collapsed[section];
  }
})();
